import type { BehaviorDomain } from '../core/types.js';
import type { RescueModule } from './rescue-types.js';

export interface ModuleFilterInput {
  /** Domain of the habit the rescue is being launched for. */
  domain?: BehaviorDomain | undefined;
  /** When true, only modules marked reducedMotionSafe pass. */
  reducedMotion?: boolean | undefined;
  /** When true, allow experimental modules (default rotation hides them). */
  includeExperimental?: boolean | undefined;
}

/**
 * Filter rescue modules according to the user's domain and motion preference.
 * - Modules whose `excludeForDomains` includes the active domain are hidden.
 * - Gambling-like modules are hidden from the gambling domain regardless of
 *   their explicit exclude list (defense in depth).
 * - Experimental modules are hidden unless `includeExperimental` is set.
 * - Reduced-motion users only see modules flagged `reducedMotionSafe`.
 */
export function filterModules(
  modules: readonly RescueModule[],
  input: ModuleFilterInput,
): RescueModule[] {
  const domain = input.domain;
  const reducedMotion = input.reducedMotion === true;
  const includeExperimental = input.includeExperimental === true;
  return modules.filter((m) => {
    if (!includeExperimental && m.safety.experimental) return false;
    if (domain && m.safety.excludeForDomains.includes(domain)) return false;
    if (domain === 'gambling' && m.safety.gamblingLike) return false;
    if (reducedMotion && !m.safety.reducedMotionSafe) return false;
    return true;
  });
}
